import { query, style, group, animate, trigger, transition } from '@angular/animations';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { setValidationForm, setErrorMessageForm } from '@common/helpers/utils';
import { ExerciseService } from 'projects/shared-lib/src/lib/services/exercise.service';
import { AppService } from 'projects/admin/src/app/core/services/app.service';


const left = [
  query(':enter, :leave', style({ position: 'fixed', width: '100%' }), { optional: true }),
  group([
    query(':enter', [style({ transform: 'translateX(-100%)' }), animate('.5s ease-out', style({ transform: 'translateX(0%)' }))], {
      optional: true,
    }),
    query(':leave', [style({ transform: 'translateX(0%)' }), animate('.5s ease-out', style({ transform: 'translateX(100%)' }))], {
      optional: true,
    }),
  ]),
];

const right = [
  query(':enter, :leave', style({ position: 'fixed', width: '100%' }), { optional: true }),
  group([
    query(':enter', [style({ transform: 'translateX(100%)' }), animate('.5s ease-out', style({ transform: 'translateX(0%)' }))], {
      optional: true,
    }),
    query(':leave', [style({ transform: 'translateX(0%)' }), animate('.5s ease-out', style({ transform: 'translateX(-100%)' }))], {
      optional: true,
    }),
  ]),
];

@Component({
  selector: 'app-new-exercise',
  templateUrl: './new-exercise.component.html',
  styleUrls: ['./new-exercise.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('animSlider', [
      transition(':increment', right),
      transition(':decrement', left),
    ]),
  ],
})
export class NewExerciseComponent implements OnInit {
  @Input() project;
  slide = 0;
  isCreating = false;
  exerciseId = null;
  form: FormGroup = this.fb.group({
    period:[null, [Validators.required]],
  })
  validationMessages = {
    period: [{ type: 'required', message: 'VALIDATOR.EXERCISE_DATE_REQUIRED' }],
  }

  isControlValid = setValidationForm(this.form);
  getErrorMessage = setErrorMessageForm(this.form, this.validationMessages);
  constructor(
    private fb: FormBuilder,
    private exerciseService: ExerciseService,
    private cdr: ChangeDetectorRef,
    private appservice: AppService

  ) { }

  ngOnInit(): void {
    this.form.reset();
    this.exerciseId = null;
    this.isCreating = false;
    // console.log("Project ", this.project)
  }

  async onSubmit(){
    this.form.markAllAsTouched();
    if (this.form.valid){
      this.isCreating = true;
      const data = {
        project:this.project,
        period: this.form.value.period
      };
      const exercise =  await this.exerciseService.create(data);
      if (exercise){
        this.exerciseId = exercise.id;
        this.slide = 1;
      } else{
        this.slide = 2;
      }

      this.form.reset();
      this.isCreating = false;
      this.cdr.markForCheck();
    }
  }

  onClose(successful=false){
    if (successful){
      this.appservice.endCreateExercise(this.project.id, this.exerciseId)
    } else{
      this.appservice.endCreateExercise();
    }

  }


}
